import React from 'react';

export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-4 text-primary-600">Datenschutzerklärung</h1>
      <p className="mb-4">Wir nehmen den Schutz deiner Daten sehr ernst. Deine hochgeladenen Bilder werden ausschließlich zur Verarbeitung verwendet und nicht dauerhaft gespeichert. Es erfolgt keine Weitergabe an Dritte (außer zur KI-Verarbeitung über unsere Partner-API). Weitere Details findest du in unseren Nutzungsbedingungen.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Verantwortlicher</h2>
      <p className="mb-4">Max Mustermann<br/>Musterstraße 1<br/>12345 Musterstadt<br/>E-Mail: info@naturalme.de</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Welche Daten werden verarbeitet?</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Bilder, die du hochlädst (temporär, nur zur KI-Verarbeitung)</li>
        <li>IP-Adresse (zur Missbrauchsprävention und Limitierung)</li>
      </ul>
      <h2 className="text-xl font-semibold mt-8 mb-2">Deine Rechte</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Auskunft, Löschung, Berichtigung deiner Daten</li>
        <li>Widerspruch gegen die Verarbeitung</li>
      </ul>
      <p className="mt-8">Für Fragen zum Datenschutz kontaktiere uns jederzeit per E-Mail.</p>
    </div>
  );
}
